export const FORCE_RELOAD_DELAY_MS = 10_000

let timerId: number | undefined

export const startForceReloadTimer = () => {
  cancelForceReloadTimer()
  timerId = window.setTimeout(() => location.reload(), FORCE_RELOAD_DELAY_MS)
}

export const cancelForceReloadTimer = (): boolean => {
  if (timerId !== undefined) {
    clearTimeout(timerId)
    timerId = undefined
    return true
  }
  return false
}
